import { defineStore } from "pinia"
import { fetchUsers } from "@/api/user"
import { fetchDashboardData } from "@/api/dashboard"
import { fetchSingleUser } from "@/api/user"

export const userStore = defineStore("user", {
  state: () => ({
    users: [],
    stat: [],
    singleUser: null,
  }),

  actions: {
    async loadUsers() {
      const res = await fetchUsers()
      this.users = res.data.data
    },

    async loadDashboardData() {
      const res = await fetchDashboardData()
      this.stat = res.data.data
    },

    async loadSingleUser(id) {
      try {
        const res = await fetchSingleUser(id)
        this.singleUser = res.data.data
      } catch (error) {
        console.error("Failed to load user:", error)
      }
    },
  }
})